var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D3670AF1-B1FF-4D16-8791-7097A5BA95FB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Communication",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "messagingCreateNewConversationUserList",
    transform: "translate(-1170.000000, -347.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "groupChatBody",
    transform: "translate(390.000000, 255.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "navigationTwoTabs",
    transform: "translate(400.000000, 65.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tab_Navigation/--Tabs/Icon_+_Label",
    transform: "translate(287.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(93.600000, 27.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.727273, 4.363636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.05050505,15.2727273 L14.2222222,15.2727273 L14.2222222,12.7272727 L9.05050505,12.7272727 L9.05050505,15.2727273 Z M0,0 L0,2.54545455 L23.2727273,2.54545455 L23.2727273,0 L0,0 Z M3.87878788,8.90909091 L19.3939394,8.90909091 L19.3939394,6.36363636 L3.87878788,6.36363636 L3.87878788,8.90909091 Z",
    id: "Shape"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.ff857037c4579b624d7e95ae2c468bf1.svg";
export { ForwardRef as ReactComponent };